
import { currentHostWithProtocol } from 'bits/location'
import { Component, Prop, Vue } from 'bits/vue'
import blackLogo from 'images/padlet_logo_black.svg'
import rainbowLogo from 'images/padlet_logo_rainbow.png'
import whiteLogo from 'images/padlet_logo_white.svg'

export enum LogoType {
  SingleColor = 'SingleColor',
  Rainbow = 'Rainbow',
  Light300 = 'Light300',
  Dark300 = 'Dark300',
}

@Component({})
export default class PadletLogo extends Vue {
  @Prop({ default: false }) darkMode!: boolean
  @Prop({ required: false }) href!: string
  @Prop({ default: LogoType.SingleColor }) type?: LogoType

  currentHostWithProtocol = currentHostWithProtocol
  LogoType = LogoType

  get logo(): string {
    if (this.type === LogoType.Rainbow) {
      return rainbowLogo
    }
    if (this.type === LogoType.Light300) {
      return whiteLogo
    }
    if (this.type === LogoType.Dark300) {
      return blackLogo
    }
    return this.darkMode ? whiteLogo : blackLogo
  }
}
